module.exports = __webpack_public_path__ + "img/undraw_video_influencer_9oyy.929f94f4.svg";